import script from "./ClassButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassButton.vue?vue&type=script&setup=true&lang=js"

import "./ClassButton.vue?vue&type=style&index=0&id=f5f248f0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5f248f0"]])

export default __exports__